import { trackEvent } from '@Services/analytics/tracking.service.ts';
import { useBoundStore } from '@Store/useBoundStore.ts';
import { getFlowId } from '@Services/analytics/analytics.service.ts';

export const useWelcomeAnalytics = () => {
  const { isFromLiliApp, referralCode, partnerToken } = useBoundStore(
    (state) => state.onboardingSlice
  );
  function reportClickTnC(): void {
    trackEvent('Click TnC');
  }
  function reportClickPrivacyPolicy(): void {
    trackEvent('Click Privacy Policy');
  }
  function reportActOnSignUpPage(): void {
    trackEvent('Act on sign up page', { action: 'Clicked Get Started' });
  }
  function reportStartOnboarding(): void {
    const flowId = getFlowId();
    trackEvent('Start Onboarding', {
      referralCode,
      isFromLiliApp,
      partnerToken,
      flowId,
    });
  }

  return {
    reportClickTnC,
    reportClickPrivacyPolicy,
    reportActOnSignUpPage,
    reportStartOnboarding,
  };
};
